import { useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { DashboardFormWrapper } from '../../dashboard';
import { YardPlaceSceneModal } from '../../../design-system';
import { YardsPage } from './YardsComponents';
import { CompanyViewHeader, CompanyViewForm } from '../CompanyViewComponents';
import { useYardQuery } from '../../../hooks';
import { RoleGuard } from '../../../routes';

export const YardsView = () => {
  const params: any = useParams();
  const { data, isFetching } = useYardQuery({ id: params.id });
  const [isEdit, setIsEdit] = useState(false);

  if (isFetching) return <></>;
  if (!data) return <Navigate to={'/dashboard/yards'} replace />;

  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <YardsPage>
        <CompanyViewHeader data={data} belongsTo={'YARD'} isEdit={isEdit} setIsEdit={setIsEdit} />
        <DashboardFormWrapper flow={'row'}>
          <CompanyViewForm data={data} />
          <CompanyViewHeader
            data={data}
            belongsTo={'YARD'}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            showOnlySubmit
          />
        </DashboardFormWrapper>
      </YardsPage>
      <YardPlaceSceneModal />
    </RoleGuard>
  );
};
